export const BUFFER_RADIUS_KM = 4;
export const SPECIES_COUNT = 14;

export const PRODUCT_META = {
  id: "hp_explorer",
  title: "Himachal Tree Species Explorer",
  subtitle: `Visualize ${SPECIES_COUNT} species within a ${BUFFER_RADIUS_KM} km buffer`,
  description:
    "Select a location in Himachal Pradesh, draw a 50 km buffer, and load species distribution layers from GeoServer with a clear legend.",
};
